<template lang="pug">
  server-data(
    search-field-name="search[name]"
    :method="getRegions"
    :start-loading-value="true"
    v-slot="{ serverData: regions, loading, search }"
  )
    app-autocomplete(
      v-bind="extendAttrs"
      :loading="loading"
      :items="regions"
      @update:search-input="search"
      @input="(val) => $emit('input', val)"
    )
</template>

<script>
import { PER_PAGE } from '@/constants/pagination';

export default {
  props: {
    value: {
      type: [Number, String, Object],
      default: null,
    },
  },
  computed: {
    extendAttrs() {
      const { $attrs, value } = this;

      return {
        ...$attrs,
        value,
      };
    },
  },
  methods: {
    getRegions({ params: additionalParams }) {
      const params = {
        ...additionalParams,
        'per-page': PER_PAGE.infinity,
        sort: 'name',
      };

      return this.$api.dir.getRegions(params);
    },
  },
};
</script>
